import { JSX, useContext } from "react"
import { PciDashboardScenarioTypeEnum } from "@app/projects/network-assessment/pci-dashboard/shared";
import { getScenarioDisplay } from "@app/projects/network-assessment/pci-dashboard/shared/utility";
import { formatDateTime } from "@app/shared/formatDateTime";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { PciDashboardFiltersContext } from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardFiltersContext";

interface PciDashboardFiltersProps {
  hasFilterData: boolean;
}

const PciDashboardScenarioFilters = (props: PciDashboardFiltersProps): JSX.Element => {
  const pciDashboardFiltersContext = useContext(PciDashboardFiltersContext);

  const onCompareTimeslicesToggle = (): void => {
    if (pciDashboardFiltersContext.compareTimeslices) {
      pciDashboardFiltersContext.setSelectedScenario(null);
      pciDashboardFiltersContext.setSelectedCompareScenario(null);
    } else {
      pciDashboardFiltersContext.setSelectedScenario(PciDashboardScenarioTypeEnum.Original);
    }

    pciDashboardFiltersContext.setCompareTimeslices(!pciDashboardFiltersContext.compareTimeslices);
  }

  return (
    <div className="row align-items-top mt-3">
      <div className="col-md-2 d-flex align-items-end">
        <QESCheckbox
          checked={pciDashboardFiltersContext.compareTimeslices}
          containerClassName="mb-0"
          disabled={!props.hasFilterData || pciDashboardFiltersContext.filtersLoading}
          label="Compare Timeslices"
          testId="pci-dashboard__scenario-filters--compare-timeslices"
          onChange={() => onCompareTimeslicesToggle()}
        />
      </div>
      <div className="col-md-3">
        <QESTextInput
          disabled={true}
          label="Latest Timeslice"
          testId="pci-dashboard__scenario-filters--latest-timeslice"
          value={pciDashboardFiltersContext.compareTimeslices ? formatDateTime(pciDashboardFiltersContext.projectRunConfiguration?.dateCreated) : ""}
        />
      </div>
      <div className="col-md-3">
        <QESSelect
          disabled={!props.hasFilterData || pciDashboardFiltersContext.filtersLoading || !pciDashboardFiltersContext.compareTimeslices}
          testId="pci-dashboard__scenario-filters--compare-to"
          isValid={!!pciDashboardFiltersContext.selectedCompareScenario}
          label="Compare To"
          onChange={(e) => pciDashboardFiltersContext.setSelectedCompareScenario(e.target.value as PciDashboardScenarioTypeEnum)}
          required={pciDashboardFiltersContext.compareTimeslices}
          value={pciDashboardFiltersContext.selectedCompareScenario || ""}
        >
          {pciDashboardFiltersContext.scenarioTypes.map((scenarioType, index) => (
            <option
              key={index}
              value={scenarioType}
            >
              {getScenarioDisplay(scenarioType)}
            </option>
          ))}
        </QESSelect>
      </div>
    </div>
  );
}

export default PciDashboardScenarioFilters;